<article class="ai-message" [class.ai-message-user]="message.role === 'user'" [class.ai-message-compact]="compact">
  <div class="ai-message-label">{{ message.role === 'user' ? 'You' : 'AI Assistant' }}</div>
  <div class="ai-message-bubble" *ngIf="message.role === 'user'">{{ message.content }}</div>
  <div class="ai-message-bubble ai-markdown" *ngIf="message.role === 'assistant' && message.status !== 'failed'"
    [innerHTML]="message.content | aiMarkdown"></div>
  <div class="alert alert-danger text-start mb-0 ai-markdown" role="alert"
    *ngIf="message.role === 'assistant' && message.status === 'failed'"
    [innerHTML]="message.content | aiMarkdown"></div>
  <div class="ai-widgets" *ngIf="message.widgets.length">
    <ng-container *ngFor="let widget of message.widgets">
      <app-report-widget *ngIf="widget.template === 'report-widget'" [title]="widget.title"
        [query]="widget.query" [output]="widget.output" [visualization]="widget.visualization || 'number'"
        [showTimeControls]="true"></app-report-widget>
    </ng-container>
  </div>
</article>
